import { Categories } from "@r8er/components/marketing/categories";
import { Cta } from "@r8er/components/marketing/cta";
import { Hero } from "@r8er/components/marketing/hero";
import { Layout } from "@r8er/components/marketing/layout";
import { Newsletter } from "@r8er/components/marketing/newsletter";
import Head from "next/head";

export default function About() {
  return (
    <div>
      <Head>
        <title>Healthcare Categories - R8ER</title>
        <link rel="icon" href="/favicon.png" />
      </Head>

      <Layout>
        <Hero isSlim title="Categories" img="/categories-hero.png" />

        <Categories description="The future of healthcare will include a broad range of skills and bright ideas, many of which will fall under the categories below or a combination thereof." />

        <Cta
          title="Start your R8ER Journey Today"
          description="If you are are looking for investment or looking to invest, sign up to R8ER today."
          buttonText="Get Started"
          buttonHref="/auth/signup"
          isBlue
        />

        <Newsletter />
      </Layout>
    </div>
  );
}
